import { Component as ComponentContainer } from '@styles/layout';
import { BenefitGroupComponent, BenefitGroupType } from '@model/content';
import { BenefitsSidebar } from './BenefitsSidebar';
import { TrustBar } from './TrustBar';
import { BenefitsRow } from './BenefitsRow';

export const BenefitsGroupContainer = (props: BenefitGroupComponent) => {
  let BenefitsComponent;
  switch (props.type) {
    case BenefitGroupType.TRUST_BAR:
      BenefitsComponent = TrustBar;
      break;
    case BenefitGroupType.SIDEBAR:
      BenefitsComponent = BenefitsSidebar;
      break;
    default:
      BenefitsComponent = BenefitsRow;
      break;
  }

  return (
    <ComponentContainer isEdgeToEdge>
      <BenefitsComponent {...props} />
    </ComponentContainer>
  );
};
